import React, { useEffect, useState, useContext } from "react";
import { getProductsExpiry } from "../../../Utility/Api";
import { NaviGate } from "../../../Utility/function";
import { WarehouseContext } from "../../../Utility/UserContext";
import { Deletemodel, Pagination } from "../../Common/Functions";

const Productqty = ({ selectedProduct, openEditModal, handleCloseqty }) => {
  const [productQty, setProductQty] = useState([]);
  const { selectedWarehouse } = useContext(WarehouseContext);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);

  useEffect(() => {
    fetchProductsQty()
  }, [selectedProduct?.product_id])
  const fetchProductsQty = async (page = currentPage) => {
    try {
      console.log("fff", selectedProduct)
      const response = await getProductsExpiry(page, selectedWarehouse.id, "", selectedProduct.product_id);
      if (response.data && response.data.data) {
        setProductQty(response.data.data);
        setTotalPages(response.data.pagination.total_pages);
      }
    } catch (error) {
      console.error("Error fetching product data:", error);
    }
  };

  const handlePageChange = (pageNumber) => {
    if (pageNumber < 1 || pageNumber > totalPages) return;
    setCurrentPage(pageNumber);
    fetchProductsQty(pageNumber);
  };

  const handleAdd = (id) => {
    openEditModal(selectedProduct, id)
  }
  return (
    <div>
      <div
        className={`modal fade show`}
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        style={{ display: "block" }}
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5
                className="modal-title"
                id="exampleModalLabel"
              >
                Select Date of Product Quantity
              </h5>
            </div>
            <div className="modal-body">
              <div className="">
                <div className="table-responsive">
                  <table
                    id="example"
                    className="table table-sm table-bordered align-baseline"
                    style={{ width: "100%" }}
                  >
                    <thead>
                      <tr>
                        <th>Date</th>
                        <th>Product</th>
                        <th>Remaining</th>
                        <th>Expiry In</th>
                        <th>Import</th>
                      </tr>
                    </thead>
                    <tbody>
                      {productQty && productQty.map((item, index) => (
                        <tr>
                          <td>{new Date(item.date).toLocaleDateString()}</td>
                          <td>{item.product_name}</td>
                          <td>{item.remaining}</td>
                          <td>{item.expiry_status}</td>
                          <td>
                            <button
                              onClick={() => handleAdd(item.id)}
                              className='btn btn-primary mx-auto text-center'
                            >+</button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                <Pagination
                  currentPage={currentPage}
                  totalPages={totalPages}
                  onPageChange={handlePageChange}
                />
              </div>


            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
                onClick={() => handleCloseqty(false)}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Productqty
